export default __webpack_public_path__ + "static/media/background-bottom-left-illustration.d0ab2826.svg";